/** Chữ hiện trên màn Phòng Kinh doanh và thẻ Ghi công (QĐ 0483). */

export const UNIT_KIND_LABEL: Record<string, string> = {
  region: "Miền",
  team: "Đội",
  squad: "Tiểu đội",
};

export const ROLE_LABEL: Record<string, string> = {
  squad_lead: "Tiểu đội trưởng",
  team_lead: "Đội trưởng",
  region_lead: "Leader miền",
  head: "Trưởng phòng Kinh doanh",
};

export const MEMBER_KIND_LABEL: Record<string, string> = {
  sales: "Sales",
  cskh: "CSKH",
};

/** Nguồn khách của một bộ ghi công (bán thêm K2 máy tự tính, không chọn tay). */
export const CREDIT_KIND_LABEL: Record<string, string> = {
  fanpage: "Khách nhắn fanpage",
  self_found: "Khách tự tìm",
  referral: "Khách giới thiệu",
  returning: "Khách cũ qua CSKH",
  upsell: "Bán thêm",
};

export const CREDIT_STATUS_LABEL: Record<string, string> = {
  proposed: "Chờ duyệt",
  confirmed: "Đã duyệt",
  void: "Đã thay",
};

export function shareLabel(num: number, den: number): string {
  if (num === den) return "Trọn đơn";
  if (num === 1 && den === 2) return "Một nửa";
  if (num === 1 && den === 3) return "Một phần ba";
  return `${num}/${den}`;
}

/** Tháng hiện tại giờ Việt Nam, dạng YYYY-MM. */
export function thisMonthVN(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Ho_Chi_Minh",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(now);
  const y = parts.find((p) => p.type === "year")?.value ?? "";
  const m = parts.find((p) => p.type === "month")?.value ?? "";
  return `${y}-${m}`;
}

/** "2026-11" ⇒ "11/2026". */
export function monthText(month: string): string {
  const [y = "", m = ""] = month.split("-");
  return `${m}/${y}`;
}

/** "2026-11-05" ⇒ "05/11/2026"; rỗng ⇒ rỗng. */
export function dayText(day: string): string {
  if (!day) return "";
  const [y = "", m = "", d = ""] = day.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

/** Hệ số phần vạn ⇒ "×1,2". */
export function bpText(bp: number): string {
  return `×${(bp / 10_000).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}`;
}

/** Tỷ lệ phần vạn ⇒ "84%". */
export function percentFromBp(bp: number): string {
  return `${(bp / 100).toLocaleString("vi-VN", { maximumFractionDigits: 1 })}%`;
}

/**
 * Hạn nhập mục tiêu và món trọng điểm của tháng — bản gương của
 * `salesorg.EntryDeadline` (máy chủ vẫn là nơi chặn): 00:00 ngày 1 của tháng,
 * riêng tháng đầu cơ chế nhập tới ngày máy chủ trả ở `lateEntry` (CEO chốt 18a:
 * tháng 11/2026 tới hết 15/11).
 */
export function entryLastDay(month: string, late?: { month: string; lastDay: string }): string {
  if (late && month === late.month) return late.lastDay;
  const [y = 0, m = 1] = month.split("-").map(Number);
  const py = m === 1 ? y - 1 : y;
  const pm = m === 1 ? 12 : m - 1;
  // Ngày 0 của tháng (chỉ số 0) kế tiếp = ngày cuối của tháng `pm` — chỉ lấy SỐ NGÀY.
  const days = new Date(Date.UTC(py, pm, 0)).getUTCDate();
  return `${py}-${String(pm).padStart(2, "0")}-${String(days).padStart(2, "0")}`;
}

/** Bốn mốc chăm khách (tự đếm Chất lượng tháng, CEO 01/11/2026). */
export const CARE_KIND_LABEL: Record<string, string> = {
  reminder: "Nhắc lịch",
  prepare: "Chuẩn bị đồ",
  send_photo: "Gửi ảnh",
  follow_up: "Hỏi thăm",
};
